<template>
  <div class="d-flex">
    <InputGroup>
      <InputGroupAddon>{{ $t("global.hubInput.title") }}</InputGroupAddon>
      <Select
        :options="hubsStore.hubs"
        :default-value="activeHub"
        option-label="name"
        class="w-full"
        @change="hubsStore.changeHub($event.value)"
      />
    </InputGroup>
  </div>
</template>

<script setup>
import { useHubsStore } from "@/store"
import { ref, watch, onMounted } from "vue"

const hubsStore = useHubsStore()

const activeHub = ref(null)

const createHubWithoutPermissions = (hub) => {
  if (!hub) return null
  const hubCopy = { ...hub }
  delete hubCopy.permissions
  return hubCopy
}

onMounted(() => {
  activeHub.value = createHubWithoutPermissions(hubsStore.activeHub)
})

watch(hubsStore.activeHub, (newVal) => {
  activeHub.value = createHubWithoutPermissions(newVal)
})
</script>
